import { render } from "./NoteItem.vue?vue&type=template&id=3371b09a&scoped=true"
import script from "./NoteItem.vue?vue&type=script&lang=js"
export * from "./NoteItem.vue?vue&type=script&lang=js"

import "./NoteItem.vue?vue&type=style&index=0&id=3371b09a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3371b09a"]])

export default __exports__